import React, {useEffect, useState} from 'react';
import IconTextView from "components/input/IconTextView";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import IconRichTextView from "components/input/IconRichTextView";
import TitleAddHeader from "./TitleAddHeader";
import AutocompleteComboBox from "../../../components/input/AutocompleteComboBox";
import LeafletMapComponent from "components/map/LeafletMapComponent";
import {useHistory} from "react-router-dom";
import {addressViewModel} from "../../../viewModels/Address.viewModel";
import {getTextViewHeight, IsLP_MP_SP, IsNotLP_MP_SP} from "my-styles/media/media";
import {ALERT_TYPES} from "components/alertMassage/AlertMessage";
import messages from "res/messages/farsi";

import ICBackIcon from "res/images/back.png";
import ICCountry from 'res/images/country.png';
import ICEdit from 'res/images/edit_white.png';
import ICCity from 'res/images/city.png';
import ICNeighbourhood from 'res/images/neighbourhood.png';
import ICDone from 'res/images/done_white.png';
import ICAddress from 'res/images/address.png';
import ICTitle from "res/images/title.png";
import ICUser from 'res/images/user.png';
import ICPhone from "res/images/phone.png";

export default function AddressDetail(props) {

    const history = useHistory()
    let address = (props.location.state ? props.location.state.address : undefined)
    let fromBasket = (props.location.state ? props.location.state.fromBasket : false)

    const [isCancelled, setIsCancelled] = useState(false)
    const [key, setKey] = React.useState(1)
    const [addressName, setAddressName] = useState(
        (address && address.addrees_name) ? address.addrees_name : "")
    const [receiverName, setReceiverName] = useState(
        (address && address.full_name) ? address.full_name :
            (localStorage.getItem('full_name') ?
                localStorage.getItem('full_name') : "")
    )
    const [receiverPhone, setReceiverPhone] = useState(
        (address && address.telephone) ? address.telephone :
            (localStorage.getItem('telephone') ?
                localStorage.getItem('telephone') : "")
    )
    const [addressDesc, setAddressDesc] = useState(
        (address && address.address) ? address.address : "")
    const [selectedlocation, setSelectedlocation] = useState({
        lat: (address && address.lat_long) ?
            parseFloat(address.lat_long.split(',')[0]) : -1,
        lng: (address && address.lat_long) ?
            parseFloat(address.lat_long.split(',')[1]) : -1
    })
    const [center, setCenter] = useState({
        lat: (address && address.lat_long) ?
            parseFloat(address.lat_long.split(',')[0]) : -1,
        lng: (address && address.lat_long) ?
            parseFloat(address.lat_long.split(',')[1]) : -1
    })
    const [provinceId, setProvinceId] = useState(
        (address && address.country_id) ? address.country_id : -1)
    const [cityId, setCityId] = useState(
        (address && address.zone_id) ? address.zone_id : -1)
    const [neighbourhoodId, setNeighbourhoodId] = useState(
        (address && address.neighbourhood_id) ? address.neighbourhood_id : -1)
    const [provinces, setProvinces] = useState([])
    const [cities, setCities] = useState([])
    const [neighbourhoods, setNeighbourhoods] = useState([])
    const [selectedProvince, setSelectedProvince] = useState({})
    const [selectedCity, setSelectedCity] = useState({})
    const [selectedNeighbourhood, setSelectedNeighbourhood] = useState({})

    function requestGetProvinces() {
        addressViewModel.requestGetProvinces((data) => {
            if (isCancelled) return

            setProvinces(data.list)
            if (address && address.country_id) {
                for (let i = 0; i < data.list.length; i++) {
                    let province = data.list[i]
                    if (province.country_id === address.country_id) {
                        setSelectedProvince(province)
                        setProvinceId(province.country_id)
                        requestGetCities(address.country_id)
                        break
                    }
                }
            } else {
                props.onLoading(false)
            }
        }, () => {
            setProvinces([])
            setCities([])
            setNeighbourhoods([])
            props.onLoading(false)
        }, () => {
            props.onLoading(true)
        }, () => {

        })
    }

    function requestGetCities(countryId) {
        addressViewModel.requestGetCities(countryId, (data) => {
            setCities(data.list)
            if (address && address.zone_id) {
                for (let i = 0; i < data.list.length; i++) {
                    let city = data.list[i]
                    if (city.zone_id === address.zone_id) {
                        setSelectedCity(city)
                        setCityId(city.zone_id)
                        requestGetNeighbourhoods(address.zone_id)
                        break
                    }
                }
            } else {
                props.onLoading(false)
            }
        }, () => {
            setCities([])
            setNeighbourhoods([])
            props.onLoading(false)
        }, () => {
            props.onLoading(true)
        }, () => {

        })
    }

    function requestGetNeighbourhoods(zoneId) {
        addressViewModel.requestGetNeighbourhoods(zoneId, (data) => {
            setNeighbourhoods(data.list)
            if (address && address.neighbourhood_id) {
                for (let i = 0; i < data.list.length; i++) {
                    let neighbourhood = data.list[i]
                    if (parseInt(neighbourhood.neighbourhood_id) === parseInt(address.neighbourhood_id)) {
                        setSelectedNeighbourhood(neighbourhood)
                        setNeighbourhoodId(neighbourhood.neighbourhood_id)
                        break
                    }
                }
            }
        }, () => {
            setNeighbourhoods([])
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestAddOrEditAddress() {
        if (addressName.trim() === '' || receiverName.trim() === '' ||
            receiverPhone.trim() === '' || addressDesc.trim() === '' ||
            provinceId === -1 || cityId === -1 || neighbourhoodId === -1) {
            props.onAlert(messages.pleaseFillAllInfo)
            return
        }
        if (selectedlocation.lat === -1 || selectedlocation.lng === -1) {
            props.onAlert(messages.pleaseSelectLocation)
            return
        }
        if (!address) {
            address = {}
        }
        address.addrees_name = addressName
        address.full_name = receiverName
        address.telephone = receiverPhone
        address.address = addressDesc
        address.lat_long = selectedlocation.lat.toString() + "," + selectedlocation.lng.toString()
        address.country_id = provinceId
        address.zone_id = cityId
        address.neighbourhood_id = neighbourhoodId

        addressViewModel.requestAddOrEditAddress(address, () => {
            props.onAlert(
                address.address_id > 0 ? messages.editAddressSuccess : messages.addAddressSuccess,
                ALERT_TYPES.SUCCESS
            )
            if (fromBasket) {
                props.onNavigate(history, "/orderRegister")
            } else {
                props.onNavigate(history, "/addressList")
            }
        }, (data) => {
            if (data && data.description && data.description === 199) {
                props.onAlert(messages.cannotDeleteAddress)
            } else {
                props.onAlert(messages.addAddressError)
            }
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function changeCenter(value) {
        if (value.latitude && value.longitude) {
            value.latitude = value.latitude.toString().replace("/", ".")
            value.longitude = value.longitude.toString().replace("/", ".")
            if (parseFloat(value.latitude) > 0 && parseFloat(value.longitude) > 0) {
                setCenter({
                    lat: parseFloat(value.latitude),
                    lng: parseFloat(value.longitude),
                })
                setKey(Math.random() * 100)
            }
        }
    }

    useEffect(() => {
        requestGetProvinces()

        return () => {
            setIsCancelled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (<div>
        <div>
            <TitleAddHeader
                icon={ICBackIcon}
                title={address ? messages.editAddress : messages.addAddress}
                onIconClick={() => {
                    if (fromBasket) {
                        props.onNavigate(history, "/orderRegister")
                    } else {
                        props.onNavigate(history, "/addressList")
                    }
                }}/>
        </div>
        <div className="horizontalInWebVerticalInMobile">
            <div className="twoFromfiveInWebFullInMobile">
                <div className="marginLeftRightSmall">
                    <IconTextView
                        height={getTextViewHeight()}
                        defaultValue={addressName}
                        placeholder={messages.titleAddress}
                        icon={<img src={ICTitle} alt="" className="xxSmallIcon marginSmall"/>}
                        onChange={(e) => {
                            setAddressName(e.target.value)
                        }}
                        onEnterClick={() => {
                            requestAddOrEditAddress()
                        }}/>
                </div>
                <div className="horizontalFullScreen">
                    <div className="marginRightSmall full">
                        <IconTextView
                            height={getTextViewHeight()}
                            defaultValue={receiverName}
                            placeholder={messages.deliverTakeName}
                            icon={<img src={ICUser} alt="" className="xxSmallIcon marginSmall"/>}
                            onChange={(e) => {
                                setReceiverName(e.target.value)
                            }}
                            onEnterClick={() => {
                                requestAddOrEditAddress()
                            }}/>
                    </div>
                    <div className="marginRightSmall marginLeftSmall full">
                        <IconTextView
                            height={getTextViewHeight()}
                            defaultValue={receiverPhone}
                            placeholder={messages.deliverTakePhone}
                            icon={<img src={ICPhone} alt="" className="xxSmallIcon marginSmall"/>}
                            onChange={(e) => {
                                setReceiverPhone(e.target.value)
                            }}
                            onEnterClick={() => {
                                requestAddOrEditAddress()
                            }}/>
                    </div>
                </div>
                <div className="marginLeftRightSmall">
                    <AutocompleteComboBox
                        icon={<img src={ICCountry} alt="" className="xxSmallIcon marginSmall"/>}
                        onChange={(event, value) => {
                            if (value) {
                                setSelectedProvince(value)
                                setProvinceId(value.country_id)
                                changeCenter(value)
                                requestGetCities(value.country_id)
                            } else {
                                setProvinceId(-1)
                                setSelectedProvince(null)
                            }
                            setNeighbourhoodId(-1)
                            setSelectedNeighbourhood(null)
                            setNeighbourhoods([])
                            setCityId(-1)
                            setSelectedCity(null)
                            setCities([])
                        }}
                        defaultValue={selectedProvince}
                        options={provinces}
                        placeholder={messages.state}/>
                </div>
                <div className="horizontalFullScreen">
                    <div className="marginRightSmall full">
                        <AutocompleteComboBox
                            icon={<img src={ICCity} alt="" className="xxSmallIcon marginSmall"/>}
                            onChange={(event, value) => {
                                if (value) {
                                    setSelectedCity(value)
                                    setCityId(value.zone_id)
                                    changeCenter(value)
                                    requestGetNeighbourhoods(value.zone_id)
                                } else {
                                    setCityId(-1)
                                    setSelectedCity(null)
                                }
                                setNeighbourhoodId(-1)
                                setSelectedNeighbourhood(null)
                                setNeighbourhoods([])
                            }}
                            defaultValue={selectedCity}
                            options={cities}
                            placeholder={messages.city}/>
                    </div>
                    <div className="marginLeftRightSmall full">
                        <AutocompleteComboBox
                            icon={<img src={ICNeighbourhood} alt="" className="xxSmallIcon marginSmall"/>}
                            onChange={(event, value) => {
                                if (value) {
                                    setSelectedNeighbourhood(value)
                                    setNeighbourhoodId(value.neighbourhood_id)
                                    changeCenter(value)
                                } else {
                                    setSelectedNeighbourhood(value)
                                    setNeighbourhoodId(-1)
                                }
                            }}
                            defaultValue={selectedNeighbourhood}
                            options={neighbourhoods}
                            placeholder={messages.neighbourhood}/>
                    </div>
                </div>
                <div className="marginLeftRightSmall">
                    <IconRichTextView
                        height={"8em"}
                        defaultValue={addressDesc}
                        placeholder={messages.enterFullAddress}
                        icon={<img src={ICAddress} alt="" className="xxSmallIcon marginSmall"/>}
                        onChange={(e) => {
                            setAddressDesc(e.target.value)
                        }}/>
                </div>
                {IsLP_MP_SP() &&
                <div className="marginSmall oneFromFour" style={{float: "left"}}>
                    <IconTitleButtonRound
                        height="3em"
                        fontSize="mediumTextBold"
                        onClick={() => {
                            requestAddOrEditAddress()
                        }}
                        icon={<img
                            className="xSmallIcon"
                            src={address ? ICEdit : ICDone}
                            alt=""/>}
                        title={address ? messages.editAddress : messages.addAddress}/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                </div>
                }
            </div>
            <div className="map shadow center highZIndex_0" style={{position: "relative"}}>
                <LeafletMapComponent
                    identifier={key}
                    isEnableCurrentLocation={true}
                    enableSearch={true}
                    showMyLocation={true}
                    center={(center && center.lat > 0 && center.lng > 0) ? {
                        latitude: center.lat,
                        longitude: center.lng,
                    } : undefined}
                    markers={(selectedlocation && selectedlocation.lat > 0 && selectedlocation.lng > 0) ? [{
                        latitude: selectedlocation.lat,
                        longitude: selectedlocation.lng,
                        icon: "https://sarfe.bpc.ir/image/catalog/Standard%20Banner/home.png"
                    }] : []}
                    onCenterChange={(center) => {
                        setCenter(center)
                        setKey(Math.random() * 100)
                    }}
                    onClearSearch={() => {
                        setKey(Math.random() * 100)
                    }}
                    onClick={(event) => {
                        setSelectedlocation({
                            lat: event.latlng.lat,
                            lng: event.latlng.lng
                        })
                    }}/>
            </div>
        </div>
        {IsNotLP_MP_SP() &&
        <div className="marginSmall oneFromFour" style={{float: "left"}}>
            <IconTitleButtonRound
                height="3em"
                fontSize="mediumTextBold"
                onClick={() => {
                    requestAddOrEditAddress()
                }}
                icon={<img
                    className="xSmallIcon"
                    src={address ? ICEdit : ICDone}
                    alt=""/>}
                title={address ? messages.editAddress : messages.addAddress}/>
        </div>
        }
    </div>)

}